import React, { Fragment, Component } from 'react';
import ResetButton from './ResetButton';
import CountryRadios from './CountryRadios';
import ActivityType from './ActivityType';
import FeatureType from './FeatureType';

class NavResorts extends Component {
    getCountryNames = () => {
        const resortList = this.props.resorts;

        const reducer = (count, resort) => {
            if (!count[resort.countryCode]) {
                count[resort.countryCode] = 1;
            } else {
                count[resort.countryCode]++;
            }

            return count;
        };

        const names = resortList.reduce(reducer, {});

        return names;
    };

    getActivities = () => {
        const activityNames = Object.keys(this.props.staticActivities);
        const activitiesUsing = this.props.activityNamesUsing;

        const names = activityNames.filter(activity => {
            if (activitiesUsing.indexOf(activity) > -1) {
                return activity;
            }
        });

        return names;
    };

    render() {
        return (
            <Fragment>
                <div className="top">
                    <i
                        className="ic ic-close"
                        onClick={() => this.props.viewResorts()}
                    />
                    <h4>Filter resorts by...</h4>
                    {this.props.resetButton && (
                        <ResetButton clickHandler={this.props.resetClick} />
                    )}
                </div>
                <div className={this.props.sliderStyle ? 'flex-wrap' : ''}>
                    <div className="resorts checkbox-list">
                        <CountryRadios
                            resorts={this.getCountryNames()}
                            countryChange={this.props.countryChange}
                            activeCountries={this.props.filters.country}
                            disabled={this.props.disabledCountries}
                        />
                    </div>
                    <div className="activities checkbox-list">
                        <ActivityType
                            activities={this.getActivities()}
                            activityNamesUsing={this.props.activityNamesUsing}
                            activityChange={this.props.activityChange}
                            activeActivities={this.props.filters.activity}
                            disabled={this.props.disabledActivities}
                        />
                    </div>
                    <div className="features checkbox-list">
                        <FeatureType
                            features={this.props.features}
                            featureChange={this.props.featureChange}
                            activeFeatures={this.props.filters.feature}
                            disabled={this.props.disabledFeatures}
                        />
                    </div>
                    <div
                        className={`view-results ${
                            this.props.showButton ? 'show' : 'hide'
                        }`}
                        onClick={() => this.props.viewResorts()}
                    >
                        {`View ${this.props.activeResorts.length} Matching ${
                            this.props.activeResorts.length > 1
                                ? 'Resorts'
                                : 'Resort'
                        }`}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default NavResorts;